import { __assign, __generator, __spreadArray } from "tslib";
import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { withOffset, selectors } from '../../Stream';
import { initializeUserStream } from './actions';
import { streamType } from './constants';
import { isApiError, request } from '../../xhr';
var logger = ddt.createLogger('userlist');
function doFetchUsers(deviationid, type, offset, limit) {
    var params, result;
    if (offset === void 0) { offset = 0; }
    if (limit === void 0) { limit = 24; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    deviationid: deviationid,
                    type: type,
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/who',
                        params: params,
                    }, function () {
                        if (process.env.NODE_ENV !== 'production') {
                            var users = require('@wix/da-sample-data').users; // eslint-disable-line global-require
                            var fetchableUsers = __spreadArray(__spreadArray(__spreadArray([], users, true), users.map(function (user) { return (__assign(__assign({}, user), { userId: user.userId + 100000000 })); }), true), users.map(function (user) { return (__assign(__assign({}, user), { userId: user.userId + 200000000 })); }), true); // lots of data to test loading
                            return {
                                hasMore: fetchableUsers.length > offset + limit,
                                nextOffset: Math.min(offset + limit, fetchableUsers.length),
                                total: fetchableUsers.length,
                                results: fetchableUsers,
                            };
                        }
                        return { hasMore: false, results: [], total: 0 };
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function handleFetchUsers(_a) {
    var _b, offset, limit, streamParams, result, total, items, _c, hasMore, nextOffset;
    var streamId = _a.streamId;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    streamParams: selectors.getStreamParams(state, streamId),
                    offset: withOffset.selectors.getNextOffset(state, streamId),
                    limit: selectors.getItemsPerFetch(state, streamId),
                }); })];
            case 1:
                _b = _d.sent(), offset = _b.offset, limit = _b.limit, streamParams = _b.streamParams;
                if (!streamParams || streamParams.type !== streamType) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(doFetchUsers, streamParams.deviationId, streamParams.streamType, offset, limit)];
            case 2:
                result = _d.sent();
                if (!(!result || isApiError(result))) return [3 /*break*/, 4];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 3:
                _d.sent();
                return [2 /*return*/];
            case 4:
                total = result.total, items = result.results, _c = result.hasMore, hasMore = _c === void 0 ? false : _c, nextOffset = result.nextOffset;
                return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        items: items,
                        total: total,
                        hasMore: hasMore,
                        nextOffset: nextOffset || undefined,
                    }))];
            case 5:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function handleInitialize(_a) {
    var isInitialized, streamParams;
    var _b = _a.payload, deviationId = _b.deviationId, streamId = _b.streamId, type = _b.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 1:
                isInitialized = _c.sent();
                if (isInitialized) {
                    return [2 /*return*/];
                }
                logger.log('Initializing user stream', deviationId, type);
                streamParams = {
                    type: streamType,
                    deviationId: deviationId,
                    streamType: type,
                };
                return [4 /*yield*/, put(withOffset.actions.initialize({
                        streamId: streamId,
                        itemsPerFetch: 24,
                        items: [],
                        hasMore: true,
                        streamParams: streamParams,
                    }))];
            case 2:
                _c.sent();
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 3:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default function userRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initializeUserStream, handleInitialize),
                    takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, handleFetchUsers),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map